import type { FC, ReactNode } from 'react'

import Image from 'next/image'

import { cn } from '@/lib/utils'

interface BrandLogoProps {
    className?: string
}

/**
 * The resort's own full-colour logo, sized for the cream nav plate.
 *
 * The source is a JPG on white with generous padding, so the frame is cropped
 * to the artwork (1.5:1, scaled 1.2x around the centre) and the image is
 * multiplied onto a cream backing. White becomes the exact cream of the nav,
 * which is why this mark belongs on the light plate only.
 */
export const BrandLogo: FC<BrandLogoProps> = ({ className }): ReactNode => {
    return (
        <span
            className={cn(
                'relative block h-[36px] w-[54px] overflow-hidden bg-cream sm:h-[48px] sm:w-[72px] md:h-[58px] md:w-[87px]',
                className
            )}
        >
            <Image
                src='/images/bodins-resort-logo.jpg'
                alt=''
                fill
                priority
                sizes='(min-width: 768px) 105px, (min-width: 640px) 87px, 65px'
                className='scale-[1.2] object-cover mix-blend-multiply'
            />
        </span>
    )
}
